import React from 'react';

import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {PreviousMeetingsWidgetPlaceholder} from "../../../previous-meetings-widget/components/placeholders/previous-meetings-widget.placeholder";
import {RecentFormWidgetPlaceholder} from "../../../recent-form-widget/components/placeholders/recent-form-widget.placeholder";
import styles from '../../styles/h2h-widget.module.scss';
import classnames from "classnames";
export class H2hWidgetPlaceholderProps extends BaseProps {
  isFullView: Boolean;
  shouldUseSuspense: Boolean;
}

export const H2hWidgetPlaceholder = (props: H2hWidgetPlaceholderProps) => {
  return (
     <React.Fragment>
       {
         (props.isFullView || props.shouldUseSuspense) && <div className={classnames(styles.placeholder_tabs)}/>
       }
       <PreviousMeetingsWidgetPlaceholder isFullView={props.isFullView}/>
       <RecentFormWidgetPlaceholder isFullView={props.isFullView}/>
     </React.Fragment>
  )
};
